<template>
  <div class="address-form">
    <div style="height: 10px"></div>
    <van-form>
      <van-cell-group>
        <van-field
          input-align="right"
          v-model="formData.content"
          label="反馈内容"
          type="textarea"
          placeholder="请输入您的反馈与建议"
          :rules="[{ required: true, message: '内容不能为空' }]"
        />
        <van-field name="uploader" label="上传图片">
          <template #input>
            <PicUploader
              :fileList="formData.pic"
              :limit="3"
              :name="'pics'"
            ></PicUploader>
          </template>
        </van-field>
      </van-cell-group>

      <div style="padding: 20px; text-align: center">
        <van-button round size="large" @click.stop="formSave" class="save"
          >提交</van-button
        >
      </div>
    </van-form>
  </div>
</template>
<style scoped>
/* .van-cell{
    flex-direction: column;
} */
.address-form {
  background: #f8f8f8;
  height: 100vh;
}
.van-cell:not(:last-child)::after {
  right: 16px;
}
.save {
  width: 155px;
  height: 46px;
  background: linear-gradient(316deg, #f8d77f 0%, #fcab15 100%);
  border-radius: 23px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 20px;
  text-align: center;
}
</style>
<script>
import Vue from "vue";
import PicUploader from "@/components/picker/PicUploader.vue";
import {
  Cell,
  CellGroup,
  GoodsAction,
  GoodsActionIcon,
  GoodsActionButton,
  Sku,
  Toast,
} from "vant";

Vue.use(Cell)
  .use(CellGroup)
  .use(GoodsAction)
  .use(GoodsActionIcon)
  .use(GoodsActionButton)
  .use(Sku)
  .use(Toast);
export default {
  name: "Feedback",
  data() {
    return {
      formData: {
        content: "",
        pic: [],
      },
    };
  },
  components: {
    PicUploader,
  },
  mounted() {
    document.title = "用户反馈";
  },
  methods: {
    onChange() {
      this.$router.go(-1);
    },
    imageListChange(data) {
      console.log("data", data);
      let that = this;
      let name = data.name;
      that.formData[pic] = data.pic;
    },
    formSave() {
      let that = this;
      that.$api.post(
        "/api/feedback/Addfeedback",
        { content: that.formData.content, pic: that.formData.pic },
        (res) => {
          that.formData = {};
          Toast.success("提交成功");
          this.onChange();
        },
        (res) => {
          Toast.fail("提交失败");
          this.onChange();
        }
      );
    },
  },
};
</script>



// WEBPACK FOOTER //
// feedback.vue?62602bc4